import { render } from "./privacyCenter.vue?vue&type=template&id=66b53ab4&scoped=true"
import script from "./privacyCenter.vue?vue&type=script&lang=js"
export * from "./privacyCenter.vue?vue&type=script&lang=js"

import "./privacyCenter.vue?vue&type=style&index=0&id=66b53ab4&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b53ab4"]])

export default __exports__